import { MotionDiv } from '@/components/element/MotionDiv';
import { PaymentAmount } from '@/components/features/tasks/invoice/ToDoList/PaymentAmount';
import { useUpdateBillingAmountByMoneyForward } from '@/hooks/api/1972_update_billing_amount_by_mf';
import { toastApiError } from '@/lib/toast';
import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AccountingConfirmationCheck } from '@/components/features/tasks/invoice/ToDoList/AccountingConfirmationCheck';
import { useUpdateBillingAmountByBoard } from '@/hooks/api/2530_invoice_board_amount';

export const ToDoList = () => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { sales_order_id } = useParams();
  const { invoiceTask: task, setInvoiceTask } = useCurrentInvoiceTask();
  const { mutate, data, isPending, error } = useUpdateBillingAmountByMoneyForward();
  const {
    mutate: mutateUpdateBillingAmountByBoard,
    data: dataUpdateBillingAmountByBoard,
    isPending: isPendingUpdateBillingAmountByBoard,
    error: errorUpdateBillingAmountByBoard,
  } = useUpdateBillingAmountByBoard();
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    if (task) {
      setDisabled(!['preparing', 'confirming'].includes(task!.invoice_task_phase.name));
    }
  }, [task]);

  useEffect(
    () => setShowLoading(isPending || isPendingUpdateBillingAmountByBoard),
    [isPending, isPendingUpdateBillingAmountByBoard]
  );
  useEffect(() => toastApiError(error || errorUpdateBillingAmountByBoard), [error, errorUpdateBillingAmountByBoard]);

  useEffect(() => {
    if (data) {
      setInvoiceTask(data);
    }
  }, [data]);

  useEffect(() => {
    if (dataUpdateBillingAmountByBoard) {
      setInvoiceTask(dataUpdateBillingAmountByBoard);
    }
  }, [dataUpdateBillingAmountByBoard]);

  const onUpdateClick = () => {
    mutate({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      sales_order_id: Number(sales_order_id),
      task_id: task!.id,
    });
  };

  const onUpdateBillingAmountByBoardClick = () => {
    mutateUpdateBillingAmountByBoard({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      sales_order_id: Number(sales_order_id),
      task_id: task!.id,
    });
  };

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h6 className="mb-0">TODOリスト</h6>
            <p className="text-xs mb-0">TODOを処理して、タスクを次のフェーズへ移動させてください。</p>
          </div>
          {_w_!.money_forward_setting && (
            <button
              className={`btn bg-gradient-dark flex-shrink-0 ${disabled ? 'disabled' : ''}`}
              onClick={onUpdateClick}
            >
              請求書から取得
            </button>
          )}
          {task!.sales_order.sales_order_board_project && (
            <button
              className={`btn bg-gradient-dark flex-shrink-0 ${disabled ? 'disabled' : ''}`}
              onClick={onUpdateBillingAmountByBoardClick}
            >
              boardから取得
            </button>
          )}
        </div>
      </div>
      <div className="card-body pt-0">
        <ul className="list-group list-group-flush" data-toggle="checklist">
          <li className="list-group-item border-0 flex-column align-items-start ps-0 py-0 pe-0 mb-3">
            <PaymentAmount disabled={disabled} />
            <hr className="horizontal dark mt-4 mb-0" />
          </li>
          {task!.accounting_manual_mode && (
            <li className="list-group-item border-0 flex-column align-items-start ps-0 py-0 mb-3">
              <AccountingConfirmationCheck disabled={disabled} />
              <hr className="horizontal dark mt-4 mb-0" />
            </li>
          )}
        </ul>
      </div>
    </MotionDiv>
  );
};
